import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { VALIDATION_MESSAGES, ValidationMessage } from '@awo-care/utils';

/**
 * Zeigt die Validierungsfehler eines Controls als Kleintext unter dem Feld.
 *
 * Übernommen aus dem npm-Paket `anguland` (1.0.4) — Selektor, Inputs, Markup
 * und das Host-Attribut sind bewusst unverändert, damit Templates und E2E-Tests
 * unangetastet bleiben. Zum Ausbau siehe `validation-messages.ts`.
 */
@Component({
  selector: 'lib-form-error',
  host: { 'data-component': 'anguland-form-error' },
  template: `
    @for (validation of validationsForKey; track $index) {
      <ng-container>
        @if (hasError(validation.type)) {
          <small class="smallError">
            {{ validation.message }}
          </small>
        }
      </ng-container>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .smallError {
        color: #f44336;
        font-size: 0.7rem;
      }
    `,
  ],
})
export class FormErrorComponent {
  readonly VALIDATION_MESSAGES = VALIDATION_MESSAGES;

  formGroup = input.required<FormGroup>();
  controlName = input.required<string>();
  validationKey = input.required<string>();

  get validationsForKey(): ValidationMessage[] {
    // Der Index-Signatur-Typ von VALIDATION_MESSAGES verspricht tsc einen
    // Treffer fuer jeden String; ein unbekannter validationKey liefert
    // trotzdem undefined, und @for darueber wirft zur Laufzeit und leert das
    // ganze Formular. Alle heutigen Aufrufer nutzen bekannte Keys — der
    // Fallback haelt das so, wenn jemand einen neuen einfuehrt.
    return this.VALIDATION_MESSAGES[this.validationKey()] ?? [];
  }

  get control() {
    return this.formGroup().get(this.controlName());
  }

  hasError(errorType: string): boolean {
    return (
      (this.control?.hasError(errorType) &&
        this.control?.touched &&
        !this.control?.pristine) ||
      false
    );
  }
}
